// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".component-input-investments .list .item[data-v-7dd34930]{background:#fff;border-bottom:1px solid #dadce1}", ""]);
// Exports
module.exports = exports;
